import { FC, useState, useEffect } from "react";
import { Chip, Divider, Grid, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import CustomSelect, { IOptions } from "../../FormFields/CustomSelect";
import CustomTextField from '../../FormFields/CustomTextField';
import { useAppSelector } from "../../../store/hooks";
import { fetchStates } from '../../../store/stateStore/stateThunk';

interface LegalProps {
  selected: any;
  methods:  any;
  isEdit?: boolean;
}

// Legal component
const Legal: FC<LegalProps> = ({selected, methods, isEdit}) => {
  const [countryOptions, setCountryOptions] = useState<IOptions[]>([]);
  const [country, setCountry] = useState('');
  const [stateOptions, setStateOptions] = useState<IOptions[]>([]);
  const [legalState, setLegalState] = useState('');
  const countriesList = useAppSelector(state => state.country.countries);
  const coutryStateList = useAppSelector(state => state.countryState.countryStates);

  useEffect(() => {
    console.log("debugging address data");
    console.log(selected);
    console.log(isEdit);
    console.log("debugging address data end");

    const setInitialData = () => {
      if(selected) {
        methods.setValue('registrationNo', selected?.registrationNo);
        methods.setValue('countryOfRegistration', selected?.countryOfRegistration?._id || '');
        methods.setValue('stateOfRegistration', selected?.stateOfRegistration?._id || '');
        methods.setValue('taxIdentificationNumber1', selected?.taxIdentificationNumber1);
        methods.setValue('taxIdentificationNumber2', selected?.taxIdentificationNumber2);
        setCountry(selected?.countryOfRegistration?._id)
        setLegalState(selected?.stateOfRegistration?._id)
      }
    }

    setInitialData();
    setCountryOptions(countriesList.map((c: any) => {
      return { label: c.name, value: c._id }
    }));
    setStateOptions(coutryStateList.map((c: any) => {
      return { label: c.name, value: c._id }
    }));
    
  }, [selected, countriesList, methods]);

  return (
    <>
    {/* <Grid item xs={12}>
    <Typography variant="body1">{'Registration & Legal'}</Typography>
    </Grid> */}
    <Grid item xs={12} mt={1}>
      <Divider style={{marginRight:-8}}>
          <Chip label="Registration & Legal" size="small" />
        </Divider>
      </Grid> 
      <Grid item xs={4}>
      <h5 className='c-label'>Company Registration Number</h5>
                    <TextField
                    placeholder='Registration Number' 
                    className='c-text-field' 
                    {...methods.register('registrationNo')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    required
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected && !isEdit)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.registrationNo?.message ?? ""}</p>
                    
      </Grid>
      <Grid item xs={4}>
      <h5 className='c-label'>State of Registration</h5>

      {stateOptions?.length && 
        <Select
          className='c-text-field' 
          {...methods.register('stateOfRegistration')}
          disableUnderline
          required
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1.5px solid #e9ecf1",
                // width: 255,
                // marginLeft:'-29px !important',
                boxShadow: 'none',
                borderRadius: '5px'
              }
            }
            }}
          style={{width:'100%'}}
          value={legalState ? legalState : ''}
          disabled={(selected && !isEdit)? true : false}
          onChange={(event: SelectChangeEvent<any>) => {
            setLegalState(event.target.value);
          }}
          size='small'
          variant='outlined'
          sx={{
            boxShadow: "none",
            // fontSize:12,
            textAlign:'right',
            '& .MuiOutlinedInput-input': {p: 0.5},
            // '& .MuiSelect-select': { p:0 },
            marginBottom:'3px',
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
          }}
        >
          {stateOptions && stateOptions.map((option)=>
            <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
          )}
        </Select>}
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.stateOfRegistration?.message ?? ""}</p>
      </Grid>
      <Grid item xs={4}>
      <h5 className='c-label'>Country of registration</h5>
        {countryOptions?.length && <Select
                          className='c-text-field' 
                          {...methods.register('countryOfRegistration')}
                          disableUnderline
                          required
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                border: "1.5px solid #e9ecf1",
                                // width: 255,
                                // marginLeft:'-29px !important',
                                boxShadow: 'none',
                                borderRadius: '5px'
                              }
                            }
                            }}
                          style={{width:'100%'}}
                          value={country ? country : ''}
                          disabled={(selected && !isEdit)? true : false}
                          onChange={(event: SelectChangeEvent<any>) => {
                            setCountry(event.target.value);
                          }}
                          size='small'
                          variant='outlined'
                          sx={{
                            boxShadow: "none",
                            // fontSize:12,
                            textAlign:'right',
                            '& .MuiOutlinedInput-input': {p: 0.5},
                            // '& .MuiSelect-select': { p:0 },
                            marginBottom:'3px',
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                          }}
                        >
                        {countryOptions && countryOptions.map((option)=>
                            <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                          )}
                          </Select>}
                          <p style={{color: "#c33b3b"}}>{methods.formState.errors.countryOfRegistration?.message ?? ""}</p>
      </Grid>
      <Grid item xs={4}>
      <h5 className='c-label'>PAN Number</h5>
                    <TextField
                    placeholder='PAN Number' 
                    className='c-text-field' 
                    {...methods.register('taxIdentificationNumber1')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    required
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected && !isEdit)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.taxIdentificationNumber1?.message ?? ""}</p>
      </Grid>
      <Grid item xs={4}>
      <h5 className='c-label'>GST Number</h5>
                    <TextField
                    placeholder='GST Number' 
                    className='c-text-field' 
                    {...methods.register('taxIdentificationNumber2')}
                    variant="standard" 
                    sx={{width:'100%'}}
                    required
                    size='small'
                    InputProps={{
                      disableUnderline: true,
                      readOnly: (selected && !isEdit)? true : false
                    }}/>
                    <p style={{color: "#c33b3b"}}>{methods.formState.errors.taxIdentificationNumber2?.message ?? ""}</p>
      </Grid>
    </>
  );
};

export default Legal;
